module.exports = __webpack_public_path__ + "static/join_complete_pattern@2x-059947e5428edfe92cd4d59ab92fa294.png";